<template>
  <div
    :class="{ is_mobile: !$tools.isPc() }"
    class="page_middle_container page_middle_project_detail"
  >
    <div class="page_middle_title">费用支出申请-外部费用-发票信息审核</div>

    <!-- <div class="page_middle_content">
        <div class="page_middle_body">
          <div class="page_middle_row">
            <div class="page_middle_row_td">
              <div class="page_middle_row_key">
                <span class="page_middle_row_key_required">*</span>项目号：
              </div>
              <div class="page_middle_row_value">
                <el-input :disabled="true" v-model="data.project_number">
                </el-input>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    <div class="page_middle_content">
      <div class="page_middle_body">
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_value">
              <el-table
                class="invoice_table"
                :data="tableData"
                border
                max-height="500"
                style="margin-top: 20px"
              >
                <el-table-column label="供应商名称">
                  <template #default="scope">
                    {{ scope.row.supplier_company || "暂无" }}
                  </template>
                </el-table-column>
                <el-table-column label="税号">
                  <template #default="scope">
                    {{ scope.row.supplier_duty_paragraph || "暂无" }}
                  </template>
                </el-table-column>
                <el-table-column label="发票金额(元)">
                  <template #default="scope">
                    {{ scope.row.expenses_amount || "暂无" }}
                  </template>
                </el-table-column>
                <el-table-column label="发票附件" width="300">
                  <template #default="scope">
                    <div v-if="scope.row.invoice_attachment">
                      <div
                        v-for="(
                          file, index
                        ) in scope.row.invoice_attachment.split(',')"
                        :key="index"
                      >
                        <!-- <a :href="file" target="_blank">{{
                          getFileName(file)
                        }}</a> -->
                        <span class="global_link" @click="openLink(file)">
                          {{ $tools.getFileName(file) }}
                        </span>
                        <!-- <el-image :src="file" fit="scale-down"
                              :preview-src-list="scope.row.invoice_attachment.split(',')">
                            </el-image> -->
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="审批结果">
                  <template #default="scope">
                    <div v-if="scope.row.executor_status != 0 || isWatch">
                      {{ config.auditStatusText[scope.row.executor_status] }}
                    </div>
                    <div v-else>
                      <el-select
                        v-model="scope.row.executor_status_input"
                        filterable
                        placeholder="请选择审批结果"
                      >
                        <el-option :value="1" label="真"></el-option>
                        <el-option :value="2" label="假"></el-option>
                      </el-select>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="审核意见">
                  <template #default="scope">
                    <div v-if="scope.row.executor_status != 0 || isWatch">
                      {{ scope.row.executor_reason || "无" }}
                    </div>
                    <div v-else>
                      <el-input
                        type="textarea"
                        rows="3"
                        v-model="scope.row.executor_reason"
                        placeholder="请输入审核意见"
                      >
                      </el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="120"
                  fixed="right"
                  v-if="!isWatch"
                >
                  <template #default="scope">
                    <el-button
                      :type="
                        scope.row.executor_status != 0 ? 'info' : 'primary'
                      "
                      :disabled="scope.row.executor_status != 0"
                      style="width: 100%"
                      @click="doCommit(scope.row)"
                      :loading="scope.row.loading"
                      >审核</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <input
      type="file"
      multiple
      v-show="false"
      v-if="resetFile"
      ref="selectFile"
    />
  </div>
</template>
  <script>
// import Attachment from "@/components/unit/attachment";

import { moneyInput } from "@/utils/validate";
export default {
  name: "page_middle",
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  //type 0 是内部费用 1 外部费用
  data() {
    return {
      resetFile: false,
      isQuestion: { 0: false, 1: false },
      dialogVisible: false,
      dialogImageUrl: "",
      tableData: [
        {
          supplier: "供应商",
          duty_paragraph: "税号",
          money: 1000, //发票金额
          invoiceFile:
            "https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg", //发票附件
          executor_status: "", //审批结果
          executor_status_input: "", //审批结果
          executor_reason: "", //审核意见
        },
      ],
      data: {},
      config: {
        auditStatusText: ["未审核", "真", "假"],
        contractType: this.$config.types.contractType,
        isRequired: {
          isRequired: false,
          title: "请添加发票附件：",
        },
        otherRequired: {
          isRequired: false,
          title: "其他支付证明材料附件：",
        },
      },
      isWatch: false,
      loading: false,
    };
  },
  components: {
    // Attachment,
    // UploadPic,
  },
  created() {
    this.query = { ...this.$route.query };
    // console.log("object :>> ", this.item);
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      let project_id = this.query.id;
      let url = this.$tools.getURL(
        this.$urls.projectList.external_invoice_audit_list,
        { project_id: project_id, page: 1, pagesize: 999 }
      );
      this.$axios
        .get(url)
        .then((res) => {
          this.tableData = res.data;
          this.tableData.forEach((e) => {
            e.executor_status_input = e.executor_status || "";
            e.loading = false;
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPlaceholder(text) {
      return text;
    },
    changeContractAmount() {
      this.data.contractAmount = moneyInput(this.data.contractAmount);
    },
    changeMoney(index) {
      if (typeof index == "number") {
        this.tableData[index].money = moneyInput(this.tableData[index].money);
      } else {
        this.data.totalMoney = moneyInput(index);
      }
    },
    openLink(url) {
      this.$tools.downLoadFile(url);
    },
    getFileName(v) {
      return v.substring(v.lastIndexOf("/") + 1);
    },
    formatData(data) {
      if (!data.executor_status_input) {
        this.$tips.error({ text: "请选择审批结果" });
        return false;
      }
      if (data.executor_status_input == 2 && data.executor_reason == "") {
        this.$tips.error({ text: "请输入审核意见" });
        return false;
      }
      return true;
    },
    doCommit(data) {
      if (data.loading || !this.formatData(data)) {
        return;
      }
      let submitData = {
        id: data.id,
        executor_status: data.executor_status_input,
        executor_reason: data.executor_reason,
        operation_url: window.location.href,
      };
      data.loading = true;
      this.$axios
        .post(this.$urls.projectList.audit_invoice_info, submitData)
        .then(() => {
          this.$tips.success({ text: "审核完成" });
          data.loading = false;
          this.initData();
        })
        .catch((err) => {
          console.log(err);
          setTimeout(() => {
            data.loading = false;
          }, 1);
        });
    },
  },
};
</script>
  <style>
.page_middle_project_detail .page_middle_row_value {
  display: flex;
  align-items: center;
}
.flex-column {
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.flex-justify-content-start {
  justify-content: start;
}
.zIndexBold {
  z-index: 1000;
  position: relative;
}
.is_mobile * {
  font-size: 1.25rem;
}
.is_mobile .page_middle_row {
  align-items: initial;
  flex-direction: column;
}
.is_mobile .page_middle_row .page_middle_row_td {
  margin-bottom: 10px;
}
.is_mobile .project_number_input {
  flex-direction: initial;
  align-items: center;
}
.is_mobile .page_middle_row_td_textarea .el-textarea {
  width: 60%;
}
.is_mobile .page_middle_row_key.page_middle_row_key_left {
  text-align: left;
  flex: 50px 0 0;
}

.invoice_table .el-input,
.invoice_table .el-select {
  width: 100% !important;
}
.icon_size {
  font-size: 30px;
  margin-right: 16px;
}

.el-dialog__body img {
  width: 100%;
  object-fit: contain;
  /* height: 100%; */
}

.invoice_attachment {
  display: flex;
  flex-wrap: wrap;
}
.invoice_attachment .el_image_container {
  height: 105px;
  width: 120px;
  display: flex;
  margin-right: 10px;
  margin-bottom: 10px;
  flex-direction: column;
  justify-content: center;
}
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 80px;
  font-size: 16px;
  border: 1px solid #a1a1a1;
  padding: 4px;
  color: #606266;
}
</style>
  